<template>
  <div data-v-d005d1d5="" class="contents">
    <nav data-v-d005d1d5="" class="nav_mobile_top">
      <div data-v-d005d1d5="" class="nav_content">
        <div data-v-d005d1d5="" class="nav_left nav_left1">
          <div data-v-d005d1d5="" class="back" @click="$router.go(-1)">
            <img
              data-v-d005d1d5=""
              src="../../assets/img/arrow_back.d5eef796-0de7d3ca.svg"
              alt=""
            />
          </div>
          <div data-v-d005d1d5="" class="nav_name2">
            {{ $t('uploadproof') }}
          </div>
          <div data-v-d005d1d5="" class="start"></div>
        </div>
      </div>
    </nav>
    <div data-v-d005d1d5="" class="empty-box"></div>
    <div data-v-d005d1d5="" class="contents-box">
      <div data-v-d005d1d5="" class="upTitle">{{ $t('uploadproof') }}</div>
      <div data-v-d005d1d5="" class="content-box-left">
        <div data-v-d005d1d5="">
          <van-uploader :after-read="afterRead" :before-read="beforeRead">
            <!--v-if-->
            <div class="el-upload el-upload--text" tabindex="0">
              <!--v-if-->
              <div data-v-d005d1d5="" class="imgs">
                <img
                  data-v-d005d1d5=""
                  src="../../assets/img/icon_upload.65adbe1c-1433ffe3.svg"
                  v-if="!hasimg"
                /><!---->
                <img
                  data-v-d005d1d5=""
                  :src="uploadimg"
                  style="max-height: 172px"
                  v-else
                /><!---->
              </div>
              <div data-v-d005d1d5="" class="preview" v-if="!hasimg">
                {{ $t('xzzztupi') }}
                <span data-v-d005d1d5="">{{ $t('yulanss') }}</span>
              </div>
              <div data-v-d005d1d5="" class="file-type" v-if="!hasimg">
                {{ $t('scjjjtt') }}
              </div>
              <input
                class="el-upload__input"
                name="file"
                accept=""
                type="file"
              />
            </div>
          </van-uploader>
          <!--v-if--><!--v-if-->
        </div>
      </div>
      <div data-v-d005d1d5="" class="input-list">
        <div data-v-d005d1d5="" class="inputs inputs-max">
          <div data-v-d005d1d5="" class="lable">{{ $t('amountt') }}</div>
          <div data-v-d005d1d5="" class="input-content">
            <input
              data-v-d005d1d5=""
              type="text"
              v-model="amount"
              onchange="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
              onkeyup="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
              onafterpaste="this.value=this.value.replace(/^\D*(\d{0,9}(?:\.\d{0,9})?).*$/g,'$1')"
            /><span data-v-d005d1d5="" class="option">USDT</span>
          </div>
        </div>
        <div data-v-d005d1d5="" class="input-list">
          <div data-v-d005d1d5="" class="inputs inputs-max">
            <div data-v-d005d1d5="" class="lable">{{ $t('jiaoyihaxi') }}</div>
            <div data-v-d005d1d5="" class="input-content">
              <input
                data-v-d005d1d5=""
                type="text"
                v-model="hash"
                onchange="this.value=this.value.replace(/[^(a-zA-Z)\d]/g,'')"
                onkeyup="this.value=this.value.replace(/[^(a-zA-Z)\d]/g,'')"
                onafterpaste="this.value=this.value.replace(/[^(a-zA-Z)\d]/g,'')"
                maxlength="6"
                :placeholder="$t('houliuwi')"
              />
            </div>
          </div>
        </div>
        <div data-v-d005d1d5="" class="infos">
          {{ $t('shancgyuasm') }}
        </div>
        <div data-v-d005d1d5="" class="confirm-button" @click="submit">
          {{ $t('confirm') }}
        </div>
      </div>
      <div data-v-d005d1d5="" class="loadingbox" style="display: none"></div>
    </div>
  </div>
</template>
<script>
import '../../assets/css/index-c925edae.css'
import '../../assets/css/514.cbfba8eb.css'
import html2canvas from 'html2canvas'
import Clipboard from 'clipboard'
export default {
  data() {
    return {
      form: {},
      productvalue: 0,
      product: [],
      bizhong: 1,
      bzoptions: [{ text: 'USDT', value: 1 }],
      bizhong2: 1,
      bzoptions2: [{ text: 'CNY', value: 1 }],
      wallet: [],
      uploadimg: require('../../assets/img/icon_upload.65adbe1c-1433ffe3.svg'),
      hasimg: false,
      name: '',
      bank: '',
      bankcard: '',
      type: 0,
      product_type: '',
      product_type_id: '',
      amount: '',
      hash: '',
      coinname: 'USDT',
      payname: '',
    }
  },
  created() {},
  methods: {
    beforeRead(file) {
      if (
        file.type !== 'image/jpeg' &&
        file.type !== 'image/png' &&
        file.type !== 'image/gif'
      ) {
        this.$toast(
          this.getlang('图片格式不正确', localStorage.getItem('lang'))
        )
        return false
      }
      return true
    },
    async afterRead(file) {
      const param = new FormData()
      param.append('file', file.file)
      const { data } = await this.$http.post('/payimguppost', param)
      if (data) {
        if (data.code === '200') {
          this.uploadimg = data.data.filename
          this.hasimg = true
        }
      }
    },
    // 提交
    async submit() {
      if (!this.amount) {
        return false
      }
      if (!this.uploadimg) {
        this.$toast.fail(this.$t('czhi.upload'))
        return false
      }

      const postform = {
        coinname: this.coinname,
        hash: this.hash,
        payname: this.payname,
        num: this.amount,
        payimgs: this.uploadimg,
        rtype: 1,
      }

      const { data } = await this.$http.post('/deposithandle', postform)
      if (data) {
        if (data.code === '200') {
          this.uploadimg = ''
          this.form = {}
          this.$toast.success(data.message)
        } else {
          this.$toast.fail(this.getlang(data.msg, localStorage.getItem('lang')))
        }
      }
    },
  },
}
</script>
<style scoped lang="less"></style>
